import { PreviewMode } from '@shared/models/enums/preview-mode.enum';

export type PreviewState = {
  mode: PreviewMode;
  rulesInText: string;
  evalRules: string;
  selectedLanguage: string;
  selectedQuestion: string;
  selectedPage: string;
  sessionId: string;
};

export const DEFAULT_PREVIEW_STATE: PreviewState = {
  mode: PreviewMode.FreeFlow,
  rulesInText: 'false',
  evalRules: 'false',
  selectedLanguage: '',
  selectedQuestion: '',
  selectedPage: '',
  sessionId: '',
};
